export default "__VITE_ASSET__BlGISFl0__"